import React, { useState, useEffect } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  IconButton,
} from "@mui/material"
import api from "../../../../services/ResApi"
import { RequestErrorHandeling } from "../../../../errorHandeling/RequestErrorHandeling"
import Alerts from "../../../../errorHandeling/Alerts"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"

const CreateNewTerminalModal = ({
  editingData,
  open,
  onClose,
  setIsDataChanged,
}) => {
  const [payload, setPayload] = useState()
  const [isSubmit, setIsSubmit] = useState(false)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  useEffect(() => {
    setPayload(editingData)
  }, [editingData])

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setSuccessMessages([])
        setIsSuccess(false)
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  const handleOnChange = (e) => {
    const value = e.target.value
    setPayload({
      ...payload,
      [e.target.name]: value,
    })
    setIserror(false)
    setErrorMessages([])
  }

  const handleTerminalModalUpdate = (e) => {
    e.preventDefault()
    setIsSubmit(true)
    const finalPayload = {
      model: payload.model,
      description: payload.description,
    }
    api
      .post("/terminal/models", finalPayload)
      .then((res) => {
        setIsSubmit(false)
        setIsDataChanged(true)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setTimeout(() => {
          handleExit()
        }, 3000)
      })
      .catch((err) => {
        setIsSubmit(false)
        RequestErrorHandeling(err, setIserror, setErrorMessages, setIserrorShow)
      })
  }

  const handleExit = () => {
    onClose()
  }

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth={true}
      PaperProps={{ style: { borderRadius: "10px" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#116c6f",
          color: "white",
        }}
      >
        Update Terminal Modal
        <IconButton
          aria-label="cancel"
          sx={{ color: "#fff" }}
          onClick={handleExit}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleTerminalModalUpdate}>
        <DialogContent dividers>
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              isSuccess={isSuccess}
              successMessages={successMessages}
              iserrorShow={iserrorShow}
            />
          </div>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Grid container spacing={2} width="100%">
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="inputModelName"
                  variant="outlined"
                  name="model"
                  label="Model"
                  value={payload?.model}
                  onChange={handleOnChange}
                  required
                />
              </Grid>

              <Grid item xs={12} mt={2}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  name="description"
                  label="Description"
                  multiline
                  rows={4}
                  value={payload?.description ? payload?.description : ""}
                  onChange={handleOnChange}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={handleExit} variant="outlined" color="error">
            Cancel
          </Button>
          <LoadingButton
            loading={isSubmit}
            loadingPosition="start"
            startIcon={<SaveIcon />}
            variant="contained"
            color="success"
            type="submit"
          >
            Update
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateNewTerminalModal
